import React from 'react'

import { usePopoverContext } from 'shared/components/common/popover/PopoverContext'

import StickyFooter from 'public/components/default_template/footer/sticky_footer/StickyFooter'
import { CART_POPOVER_CONTEXT_KEY } from 'public/components/default_template/online_ordering/cart/CartModal'
import { getCheckoutEligibleItems } from 'public/components/default_template/online_ordering/cart/cartUtils'
import { useCart } from 'public/components/online_ordering/CartContext'

/* Footer shown on mobile view which opens the cart  */
export const EcommStickyFooter = ({ showFooter }: { showFooter: boolean }) => {
  const { cart } = useCart()
  const context = usePopoverContext(CART_POPOVER_CONTEXT_KEY)
  const numberOfItems = getCheckoutEligibleItems(cart)?.length || 0

  return numberOfItems && showFooter ? (
    <StickyFooter
      primaryCta={{
        text: `View order (${numberOfItems})`,
        type: 'customAction',
        onClick: () => context?.open()
      }}
    />
  ) : null
}
